import { apiClient } from "@/lib/api-client";
import type { Suggestion } from "@/types/condition";

interface SuggestionsResponse {
  data: Suggestion[];
}

export function getSuggestions(
  query: string,
  kind: string,
  locale: string,
  limit: number = 10
) {
  return apiClient.get<SuggestionsResponse>("/api/pharma/suggestions", {
    q: query,
    kind,
    locale,
    limit: String(limit),
  });
}
